import {contentLoader} from "../loader/loader";
import {useTranslation} from "react-i18next";
import {useParams} from "react-router-dom";
import {PageNotFound} from "./basic/PageNotFound";
import {BasicPage} from "./basic/BasicPage";
import {SponsorsPage} from "./sponsors/Sponsors";
import {PostsPage} from "./posts/Posts";

export const Page = () => {

    let content = contentLoader()
    const {i18n} = useTranslation();

    let {slug} = useParams()

    let _content = content.find(c => c.slug === '/pages/'+slug && c.locale === i18n.language);
    if(!_content){
        return <PageNotFound/>
    }

    if(_content.type === 'basic'){
        return <BasicPage content={_content}/>
    }
    if(_content.type === 'sponsors'){
        return <SponsorsPage content={_content}/>
    }
    if(_content.type === 'posts'){
        return <PostsPage content={_content}/>
    }

    else{
        return <PageNotFound/>
    }

}